export const PORTAL_IDS = {
  beTelecom: "beTelecom",
  chTelecom: "chTelecom",
  deTelecom: "deTelecom",
  esTelecom: "esTelecom",
  frTelecom: "frTelecom",
  itTelecom: "itTelecom",
  nlTelecom: "nlTelecom",
  plTelecom: "plTelecom",
  ukTelecom: "ukTelecom",
  usTelecom: "usTelecom"
};
